export default {
    "더불어민주당": {
        color: {
            primary: "#008ccd",
            text: "#fff",
        }},
    "미래통합당": {
        color: {
            primary: "#ef426f",
            text: "#fff",
        }},
    "정의당": {
        color: {
            primary: "#ffcc00",
            text: "#000",
        }},
    "국민의당": {
        color: {
            primary: "#ea5504",
            text: "#fff",
        }},
    "열린민주당": {
        color: {
            primary: "#003e98",
            text: "#fff",
        }},
    "기본소득당": {
        color: {
            primary: "#82c8b4",
            text: "#fff",
        }},
    "시대전환": {
        color: {
            primary: "#5a147e",
            text: "#fff",
        }},
    "민생당": {
        color: {
            primary: "#0ba95f",
            text: "#fff",
        }},
    "진보당": {
        color: {
            primary: "#d6001c",
            text: "#fff",
        }},
    "깨어있는시민연대당": {
        color: {
            primary: "#000078",
            text: "#fff",
        }},
    "무소속": {
        color: {
            primary: "#BBBBBB",
            text: "#000",
        }},
    "공석": {
        color: {
            primary: "#ffffff",
            text: "#CCC",
        }},
}